export default () =>
  !(
    process.env.NODE_ENV.toLowerCase() === "prod" ||
    process.env.NODE_ENV.toLowerCase() === "production"
  );
